import React from "react";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Button from "@insightfulscience/atomic-react/Button";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import { currency } from "@insightfulscience/smart-react/i18-formats";
import { useLocale } from "@insightfulscience/smart-react/i18";
import { useRun } from "@insightfulscience/smart-react/hocs/DiPageHoC";
import Block from "@insightfulscience/atomic-react/Block";
import useQueryParam from "@insightfulscience/smart-react/nav-hooks/useQueryParam";
import SeatsInput from "../utils-smart/SeatsInput";
import useSeats from "../selectSeatsHook";
import useFormTextRender from "../utils/useFormTextRender";
import { parseIntFromInput } from "../utils/parseIntFromInput";
import { savePriceItem } from "./action";
import { isIsul } from "../domain/plan";

const ConfigureSubscriptionForm = () => {
	const planCode = useQueryParam("planCode");
	const [t] = useLocale(
		isIsul(planCode) ? "configure-subscription-isul" : "configure-subscription",
	);
	const [textRender, stateRef] = useFormTextRender(t);
	const action = useRun(savePriceItem);
	const { updatePrice, minSeats, maxSeats, initialState, validateForm } = useSeats();

	return (
		<SmartForm {...{ initialState, action, validateForm, textRender, stateRef }}>
			<Row utility={{ justify: "center" }}>
				<Col sm={2}>
					<SmartForm.Field
						fieldClassName="mb-8"
						required
						Control={SeatsInput}
						min={minSeats}
						max={maxSeats}
						name="seats"
						id="seats"
						parseEvent={parseIntFromInput}
						setState={updatePrice}
						data-qa-selector="seats-input"
					/>
				</Col>
			</Row>
			<Row>
				<Col>
					<Paragraph
						sx={{ fontSize: "xxxl" }}
						center
						className="mb-0"
						data-qa-selector="subscription-price"
					>
						<SmartForm.ValueOf name="price">{({ value }) => currency(value)}</SmartForm.ValueOf>
					</Paragraph>
					<Paragraph
						sx={{ fontSize: "s", textAlign: "center", textTransform: "uppercase" }}
						spacing={{ mt: 1, mb: 2 }}
					>
						{t("TOTAL")}
					</Paragraph>
				</Col>
			</Row>
			<Row>
				<Col spacing={{ mt: 4, mb: 2 }}>
					<Block sx={{ textAlign: "center" }}>
						<Button type="submit" data-qa-selector="submit">
							Continue
						</Button>
					</Block>
				</Col>
			</Row>
		</SmartForm>
	);
};

export default ConfigureSubscriptionForm;
